import { useEffect, useState } from 'react';

const AudioSupport4 = ({
  unitBossId,
  audioSupportChannelVal,
  isConfigMode,
  disabled,
  isSoloPROAndSRTService,
  onUpdateAudioSupport4Channel,
}) => {
  const [is4ChannelEnabled, setIs4ChannelEnabled] = useState(
    audioSupportChannelVal === 2 ? false : true,
  );

  useEffect(() => {
    setIs4ChannelEnabled(audioSupportChannelVal === 2 ? false : true);
  }, [audioSupportChannelVal]);

  const handleToggle = async (checked) => {
    const result = await onUpdateAudioSupport4Channel(unitBossId, checked);
    if (result === false) {
      setIs4ChannelEnabled(audioSupportChannelVal === 2 ? false : true);
    } else {
      setIs4ChannelEnabled(checked);
    }
  };

  return (
    <div className={!isConfigMode ? 'ptb-2_5px' : ''}>
      {isConfigMode && (
        <div className='flex-1 pr-6 audio-support-container'>
          {isSoloPROAndSRTService && (
            <div className='d-flex align-items-center'>
              <label
                className='audio-support-label align-items-center mb-0'
                htmlFor='audioChannelToggle'
              >
                Enable 4 Audio Channels (SDI + SRT only)
              </label>
              <div className='valuetxt'>
                <input
                  type='checkbox'
                  className='toggle'
                  id='audioChannelToggle'
                  onChange={(e) => handleToggle(e.target.checked)}
                  checked={is4ChannelEnabled}
                  disabled={disabled}
                />
                <label
                  htmlFor='audioChannelToggle'
                  className='mb-0'
                  disabled={disabled}
                >
                  <span className='on'>On</span>
                  <span className='off'>Off</span>
                </label>
              </div>
            </div>
          )}
        </div>
      )}
      <div style={{ flex: 2 }}>
        {!isConfigMode && (
          <span className='audio-channel-text'>
            {is4ChannelEnabled ? '4 Audio' : '2 Audio'}
          </span>
        )}
      </div>
    </div>
  );
};

export default AudioSupport4;
